import * as Yup from "yup";

const ReviewSchema = (isEdit = false) => Yup.object().shape({
  from_user_id: Yup
    .number()
    .label("From User ID")
    .required()
    .integer(),
  to_user_id: Yup
    .number()
    .label("To User ID")
    .required()
    .integer(),
  rating: Yup
    .number()
    .label("Rating")
    .required()
    .min(1)
    .max(5),
  comment: Yup
    .string()
    .label("Comment")
    .required()
    .max(500),
});

export default ReviewSchema;
